<template>
  <div>
    <svg
      id="unemploye_rate_chart"
    ></svg>
    <br />
  </div>
</template>

<script>
import * as d3 from "d3";
export default {
  name: "PopulationRatio",
  data: function () {
    return {
      chartData: null,
    };
  },
  methods: {
    makeUnemploymentLineChart() {
      // append the svg object to the body of the page
      

      // set the dimensions and margins of the graph
      var margin = { top: 10, right: 30, bottom: 20, left: 40 },
        width = 1000 - margin.left - margin.right,
        height = 350 - margin.top - margin.bottom;

      var svg = d3.select("#unemploye_rate_chart")
      .attr("viewBox", `0 0 ${width + margin.left + margin.right} ${height + margin.top + margin.bottom}`)
      
      svg
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

      // add title
    svg.append("text")
    .style("text-anchor", "middle")
        .style("font-size", "20")
        .style("opacity","0.7")
        .attr("x",width/2)
        .attr("y","23")
        .style("font-weight","700")
        .text("Population growth from 1960 to 2020")
    
          // add y axis label
          svg.append("text")
    .style("text-anchor", "end")
        .style("font-size", "12")
        .style("opacity","0.7")
        .attr("x",margin.left -40)
        .attr("y",10)
        .attr("transform", "rotate(-90)")
        // .style("font-weight","700")
        .text("Annual population growth rate")

        // add x axis label
                svg.append("text")
    .style("text-anchor", "end")
        .style("font-size", "12")
        .style("opacity","0.7")
        .attr("x",margin.left + width - 30)
        .attr("y",margin.top + height - 28)
        // .attr("transform", "rotate(-90)")
        // .style("font-weight","700")
        .text("Years")


      // var div =
      d3.select("body")
        .append("div")
        .attr("class", "tooltip")
        .style("opacity", 0);

      //Read the data
      //d3.csv("population_retio.csv").then((d) => population_increase(d));

      //function population_increase(csv) {
      var csv = this.chartData;
      var columns = csv.columns.slice(1);
      // console.log(columns);

      var yearformat = d3.timeFormat(".%Y");
      columns.forEach((e) => {
        // e = yearformat(e);
        yearformat(e);
      });

      function trans_series(csv) {
        return {
          y: "% population_increase_retio",
          series: csv.map((d) => ({
            name: d.country,
            values: columns.map((k) => +d[k]),
          })),
          // dates: columns.map(d3.utcParse("%Y"))
          dates: columns,
        };
      }

      var data = trans_series(csv);
      // console.log(data);

      var color = d3
        .scaleOrdinal()
        .domain([
          "Japan",
          "Italy",
          "Finlad",
          "Franc",
          "Spain",
          "Unite Kingdom",
          "Canad",
          "Unite States",
          "Austrlia",
          "Icelad",
          "China",
          "Chile",
          "Turke",
          "Mexic",
        ])
        .range([
          "#67000d",
          "#67000d",
          "#67000d",
          "#67000d",
          "#67000d",
          "#a50f15",
          "#a50f15",
          "#cb181d",
          "#cb181d",
          "#cb181d",
          "#fb6a4a",
          "#fb6a4a",
          "#fc9272",
          "#fcbba1",
        ]);

      // draw x & y axis
      var x = d3
        .scaleLinear()
        .range([margin.left, width - margin.right])
        .domain(d3.extent(data.dates))
        .nice();

      var y = d3
        .scaleLinear()
        .range([height - margin.bottom, margin.top])
        .domain([-1.5, 3.5])
        .nice();

      // xAxis
      svg
        .append("g")
        .attr("transform", `translate(0,${height - margin.bottom})`)
        .attr("class", "x-axis")
        .call(d3.axisBottom(x).tickFormat(d3.format("d")));

      // yAxis
      svg
        .append("g")
        .attr("transform", `translate(${margin.left},0)`)
        .attr("class", "y-axis")
        .call(d3.axisLeft(y));

      // draw zero line
      svg
        .append("line")
        .style("stroke", "blue")
        .style("stroke-width", 1.5)
        .attr("x1", margin.left)
        .attr("x2", width - margin.right)
        .attr("y1", y(0))
        .attr("y2", y(0));

      // draw countries lines
      var line = d3
        .line()
        .defined((d) => !isNaN(d))
        .x((d, i) => x(data.dates[i]))
        .y((d) => y(d));

      // draw path
      var path = svg
        .append("g")
        .attr("fill", "none")
        // .style("stroke", "yellow")
        .attr("stroke-width", 2)
        .attr("stroke-linejoin", "round")
        .attr("stroke-linecap", "round")
        .style("mix-blend-mode", "multiply");

      data.series.forEach((c) => {
        path
          .append("path")
          .data([c])
          .attr("fill", "none")
          .style("mix-blend-mode", "multiply")
          // .style("opacity", 0.5)
          .attr("country_name", (d) => {
            //console.log('country_name is ',d.name)
            return d.name;
          })
          .attr("class", "unemploy_rate_line unemploy_rate_line--hover")
          .style("stroke", function (d) {
            return color(d.name);
          })
          .attr("d", (d) => line(d.values));
        // .on("mouseover", hover_path)
        // .on("mouseout", hover_path_out);
      });

      // try hover
      function hover(svg) {
        if ("ontouchstart" in document)
          svg
            .style("-webkit-tap-highlight-color", "transparent")
            .on("touchmove", moved)
            .on("touchstart", entered)
            .on("touchend", left);
        else
          svg
            .on("mousemove", moved)
            .on("mouseenter", entered)
            .on("mouseleave", left);

        const dot = svg.append("g").attr("display", "none");

        dot.append("circle").attr("r", 5);

        dot
          .append("text")
          .attr("font-family", "sans-serif")
          .attr("class","dot_text")
          .attr("font-size", 14)
          .attr("text-anchor", "middle")
          .attr("y", -8);

        function moved(event) {
          event.preventDefault();
          const pointer = d3.pointer(event, this);
          const xm = x.invert(pointer[0]);
          const ym = y.invert(pointer[1]);
          const i = d3.bisectCenter(data.dates, xm);
          const s = d3.least(data.series, (d) => Math.abs(d.values[i] - ym));
          // console.log(s);
          // path
          //   .attr("stroke", (d) => (d === s ? null : "#ddd"))
          //   .filter((d) => d === s)
          //   .raise();
          dot.attr(
            "transform",
            `translate(${x(data.dates[i])},${y(s.values[i])})`
          );
          dot.select("text").text(() =>{return `${s.name},${data.dates[i]},${s.values[i].toPrecision(3)}`})
          //   return `${s.name},${s.values[i].toPrecision(3));
          // dot.attr(
          //   "transform",
          //   `translate(${x(data.dates[i])},${y(s.values[i])})`
          // ).select("text").text((d, i) => {console.log('svalue:',s.values[3])
          //   return `${s.name},${s.values[i].toPrecision(3)}`;
          // });
        }

        function entered() {
          // path.style("mix-blend-mode", null).attr("stroke", "#ddd");
          dot.attr("display", null);
        }

        function left() {
          // path.style("mix-blend-mode", "multiply").attr("stroke", null);
          dot.attr("display", "none");
        }
      }

      svg.call(hover);
    },
  },
  mounted: function () {
    const API = this.$store.state.API;
    if (!this.$store.state.unemploymentLineChartData) {
      d3.csv(`${API}population_retio.csv`)
        .then((result) => {
          // console.log("result population_retio.csv is ", result);
          this.chartData = result;
          this.$store.commit("unemploymentLineChartData", result);
          this.makeUnemploymentLineChart(this.chartData);
        })
        .catch((e) => {
          console.error("Error: ", e);
        });
    } else {
      this.chartData = this.$store.state.unemploymentLineChartData;
      // console.log("vuex chartData is ", this.chartData);
      this.makeUnemploymentLineChart(this.chartData);
    }
  },
};
</script>

<style scoped>
>>> .unemploy_rate_line {
}

>>> .unemploy_rate_line--fade {
  stroke-width: 1.4px;
  opacity: 0.3;
}

>>> .unemploy_rate_line--hover {
  stroke-width: 2px;
  /* opacity: 1; */
}

>>> div.tooltip {
  position: absolute;
  text-align: center;
  pointer-events: none;

  line-height: 1;
  font-weight: bold;
  padding: 8px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  border-radius: 2px;
}

/* Creates a small triangle extender for the tooltip */
>>> div.tooltip:after {
  /* clear; */
  box-sizing: border-box;
  display: inline;
  font-size: 11px;
  top: 95%;
  left: 50%;
  line-height: 1;
  color: rgba(0, 0, 0, 0.6);
  content: "\25BC";
  position: absolute;
  text-align: center;
}

>>> .dot_text{
  text-shadow:
	-2px -2px 0 #fff,
	2px -2px 0 #fff,
	-2px 2px 0 #fff,
	2px 2px 0 #fff;
}

>>> .fade-line {
  opacity: 0.1;
}

>>> .highlight-line {
  opacity: 1;
}
>>> .normal-line {
  opacity: 0.8;
}

</style>